<template>
    <li class="nav-item dropdown">
        <a
            href="#"
            role="button"
            id="navbarDropdown"
            aria-haspopup="true"
            aria-expanded="false"
            data-toggle="dropdown"
            class="nav-link dropdown-toggle"
        >
            <img
                :src="icons[currentLocale]"
                class="country-icon as-toggle"
            />
        </a>
        <div
            aria-labelledby="navbarDropdown"
            class="dropdown-menu dropdown-menu-right"
        >
            <router-link
                v-for="locale in locales"
                :key="locale.code"
                :to="`/${locale.code}`"
                class="dropdown-item"
            >
                <img :src="icons[locale.code]" class="country-icon" />
                <span class="locale-name">{{locale.name}}</span>
            </router-link>
        </div>
    </li>
</template>

<script>
import plIcon from 'svg-country-flags/svg/pl.svg'
import enIcon from 'svg-country-flags/svg/gb-nir.svg'
import deIcon from 'svg-country-flags/svg/de.svg'
import czIcon from 'svg-country-flags/svg/cz.svg'
import skIcon from 'svg-country-flags/svg/sk.svg'
import esIcon from 'svg-country-flags/svg/es.svg'
import grIcon from 'svg-country-flags/svg/gr.svg'
import itIcon from 'svg-country-flags/svg/it.svg'
import frIcon from 'svg-country-flags/svg/fr.svg'
import huIcon from 'svg-country-flags/svg/hu.svg'

import { locales } from '../config/i18n'

export default {
  data () {
    return {
      icons: {
        pl: plIcon,
        en: enIcon,
        de: deIcon,
        cz: czIcon,
        sk: skIcon,
        es: esIcon,
        gr: grIcon,
        it: itIcon,
        fr: frIcon,
        hu: huIcon
      },
      locales
    }
  },

  computed: {
    currentLocale () {
      if (Object.keys(this.$i18n.messages).indexOf(this.$route.params.locale) === -1) {
        return 'en'
      }
      return this.$route.params.locale
    }
  },

  watch: {
    '$route.params.locale': function (lang) {
      // console.log(lang)
      if (Object.keys(this.$i18n.messages).indexOf(lang) !== -1) {
        this.locale = lang
        this.$i18n.locale = lang
      } else {
        this.locale = 'en'
        this.$i18n.locale = 'en'
      }
    }
  }
}
</script>

<style scoped>
    .country-icon {
        width: 34px;
        height: auto;
        display: inline-block;
        vertical-align: baseline;
        border: 1px solid #dee2e6;
        box-shadow: 0px 0px 0px rgba(24, 29, 38, 0.1);
    }
    .country-icon.as-toggle {
        margin-top: 5px;
    }
    .locale-name {
      display: inline-block;
      vertical-align: baseline;
      color: black;
      font-size: 14px;
      position: absolute;
      left: 75px;
    }
</style>



// WEBPACK FOOTER //
// src/components/LocaleSwitcher.vue